import script from "./PopularDevicesChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PopularDevicesChart.vue?vue&type=script&setup=true&lang=js"

import "./PopularDevicesChart.vue?vue&type=style&index=0&id=c84d545c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c84d545c"]])

export default __exports__